module.exports = __webpack_public_path__ + "static/assets/88a77444f0bb453209bf1c62becbd37c.svg";